
<template>
  <div class="userInformation">
    <div class="main" v-if="signingType && detailsType">
      <div class="top-search">
        <div class="item">
          <span>商户名称：</span>
          <div>
            <el-select v-model="userValue" placeholder="请选择">
              <el-option
                v-for="item in userOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span>订单号：</span>
          <div>
            <el-input v-model="orderCodeVal" placeholder="单行输入"></el-input>
          </div>
        </div>
        <div class="item">
          <span>状态：</span>
          <div>
            <el-select v-model="statusVal" placeholder="请选择">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span style="width: 50px;"></span>
          <el-button type="primary" @click="merchantsSearch" size="small">搜索</el-button>
          <el-button type="danger" @click="merchantsReset" size="small">重置</el-button>
        </div>
      </div>
      <!-- <div class="middle-button"><el-button type="primary" plain>下载列表</el-button></div> -->
      <div class="bottom-table">
        <el-table
          :data="userTableData"
          border
          :header-cell-style="{background:'rgb(250, 250, 250)'}"
          style="width: 100%"
        >
          <el-table-column prop="order_id" label="订单号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="merchant.name" label="商户名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="name" label="个体工商名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="legalName" label="法人姓名" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="creditCode" label="统一社会信用代码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="bstatusName" label="状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-button
                        @click="userDetails(scope.row)"
                        type="primary"
                        size="mini"
                        plain
                      >查看详情</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.bstatus == 2010">
                      <el-button
                        @click="usersSignUp(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >用户签约</el-button>
                    </el-dropdown-item>
                    <!-- <el-dropdown-item v-if="scope.row.status == 60"><el-button @click="checkEvent(scope.row)" type="danger" size="mini" plain>&emsp;审核&emsp;</el-button></el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="bottom-pag">
          <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange">
          </el-pagination>
      </div>-->
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <!-- 用户签约 -->
    <div class="main signing" v-if="!signingType">
      <div class="title">
        <div class="fanhui" @click="signingType = true">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="qianyue">用户签约</div>
      </div>
      <div class="header">
        <div class="item">个体工商户名称：{{signingObj.name || ''}}</div>
        <div class="item">统一社会信用代码：{{signingObj.creditCode || ''}}</div>
        <div class="item">
          核定成本费用率（%）：
          <div style="width:233px">
            <el-input v-model="costRate" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="item">
          含税价百分比：
          <div style="width:233px">
            <el-input v-model="taxRate" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="item">
          个税计费模式：
          <div style="width:233px">
            <el-select v-model="taxUpType" style="width:100%" placeholder="请选择">
              <el-option
                v-for="item in taxUpOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          增值税计费模式：&#12288;&#12288;&#12288;
          <div style="width:233px">
            <el-select v-model="addValueUpType" style="width:100%" placeholder="请选择">
              <el-option
                v-for="item in addValueUpOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          服务费（%）：&#8197;
          <div style="width:233px">
            <el-input v-model="serviceRate" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="item">
          发票内容：&#12288;&#12288;
          <div style="width:233px">
            <el-select v-model="invoicecontents" style="width:100%" multiple placeholder="请选择">
              <el-option
                v-for="item in detailsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <br />
        <div class="item">
          <span>备注：&#12288;&#12288;&#12288;&#12288;</span>
          <span style="width:760px">
            <el-input
              v-model="signNotes"
              type="textarea"
              :rows="4"
              resize="none"
              placeholder="请输入内容"
            ></el-input>
          </span>
        </div>
      </div>
      <div class="subtitle">普票设置</div>
      <div class="box">
        <div class="title">个税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（%）</div>
            <div class="right">速扣金额（元）</div>
          </div>
          <div class="ladder" v-for="(item,key) in commonTaxLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span>
                <el-input v-model="item.minValue" placeholder="请输入金额"></el-input>
              </span>
              <span>
                <el-input v-model="item.maxValue" placeholder="请输入金额"></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.rate" placeholder></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.quiCalDed" placeholder></el-input>
              </span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'commonTaxLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('commonTaxLadder')">添加梯度</div>
        </div>
      </div>
      <div class="box">
        <div class="title">增值税、附加税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">增值税税率（%）</div>
            <div class="right">附加税税率（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in commonOtherLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span>
                <el-input v-model="item.minValue" placeholder="请输入金额"></el-input>
              </span>
              <span>
                <el-input v-model="item.maxValue" placeholder="请输入金额"></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.zengzhiRate" placeholder></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.fujiaRate" placeholder></el-input>
              </span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'commonOtherLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('commonOtherLadder')">添加梯度</div>
        </div>
      </div>
      <div class="subtitle">专票设置</div>
      <div class="box">
        <div class="title">个税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（%）</div>
            <div class="right">速扣金额（元）</div>
          </div>
          <div class="ladder" v-for="(item,key) in specialTaxLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span>
                <el-input v-model="item.minValue" placeholder="请输入金额"></el-input>
              </span>
              <span>
                <el-input v-model="item.maxValue" placeholder="请输入金额"></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.rate" placeholder></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.quiCalDed" placeholder></el-input>
              </span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'specialTaxLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('specialTaxLadder')">添加梯度</div>
        </div>
      </div>
      <div class="box">
        <div class="title">增值税、附加税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">增值税税率（%）</div>
            <div class="right">附加税税率（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in specialOtherLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span>
                <el-input v-model="item.minValue" placeholder="请输入金额"></el-input>
              </span>
              <span>
                <el-input v-model="item.maxValue" placeholder="请输入金额"></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.zengzhiRate" placeholder></el-input>
              </span>
            </div>
            <div class="right">
              <span>
                <el-input v-model="item.fujiaRate" placeholder></el-input>
              </span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'commonOtherLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('specialOtherLadder')">添加梯度</div>
        </div>
      </div>
      <div style="width: 100%;text-align: center;">
        <el-button type="primary" @click="signingConfirm">确定</el-button>
        <el-button @click="signingType = false">取消</el-button>
      </div>
    </div>
    <!-- 详情 -->
    <div class="main details" v-if="!detailsType">
      <div class="title">
        <div class="fanhui" @click="detailsType = true">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="qianyue">客户签约</div>
      </div>
      <div class="content">
        <div class="name">执照信息</div>
        <div class="box1">
          <div class="list">
            <span>个体工商户名称：{{userListObj.name || '暂无'}}</span>
            <span>统一社会信用代码：{{userListObj.creditCode}}</span>
            <span>经营场所：{{userListObj.businessPlace}}</span>
          </div>
          <div class="list">
            <span>法人姓名：{{userListObj.legalName}}</span>
            <span>法人身份证号码：{{userListObj.idcard}}</span>
            <span>注册日期：2019-06-20</span>
          </div>
          <div class="list">经营范围：{{userListObj.businessScope}}</div>
          <div class="item">
            <div>执照照片：</div>
            <div class="picture" @click="detailsImage(userListObj.businessImg)">
              <img :src="userListObj.businessImg" alt />
            </div>
          </div>
        </div>
        <div class="name">刻章信息</div>
        <div class="box1">
          <div class="item">
            <div>公章：</div>
            <div class="picture" @click="detailsImage(userListObj.gongzhang)">
              <img :src="userListObj.gongzhang" alt />
            </div>
          </div>
          <div class="item">
            <div>发票章：</div>
            <div class="picture" @click="detailsImage(userListObj.fapiaozhang)">
              <img :src="userListObj.fapiaozhang" alt />
            </div>
          </div>
          <div class="item">
            <div>法人章：</div>
            <div class="picture" @click="detailsImage(userListObj.farenzhang)">
              <img :src="userListObj.farenzhang" alt />
            </div>
          </div>
          <div class="item">
            <div>财务章：</div>
            <div class="picture" @click="detailsImage(userListObj.caiwuzhang)">
              <img :src="userListObj.caiwuzhang" alt />
            </div>
          </div>
          <div class="item">
            <div>合同章：</div>
            <div class="picture" @click="detailsImage(userListObj.hetongzhang)">
              <img :src="userListObj.hetongzhang" alt />
            </div>
          </div>
        </div>
        <div class="name">开户信息</div>
        <div class="box1">
          <div class="list">
            <span>银行开户：{{userListObj.isBank}}</span>
            <span>账户名称：{{userListObj.bankName}}</span>
            <span>账号：{{userListObj.bankNo}}</span>
          </div>
          <div class="list">
            <span>开户行：{{userListObj.bank}}</span>
          </div>
          <div class="item">
            <div>账户：</div>
            <div class="picture" @click="detailsImage(userListObj.bankImg)">
              <img :src="userListObj.bankImg" alt />
            </div>
          </div>
        </div>
        <div class="name">税务报道</div>
        <div class="box1">
          <div class="item">
            <div>CA：</div>
            <div class="picture" @click="detailsImage(userListObj.caImg)">
              <img :src="userListObj.caImg" alt />
            </div>
          </div>
          <div class="item">
            <div>税务登记日：{{userListObj.taxRegDay || '暂无'}}</div>
          </div>
          <div class="item">
            <div>税务机构名称：{{userListObj.taxOrg || '暂无'}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图片查看 -->
    <el-dialog title="图片查看" :visible.sync="dialogImg" width="50%" :before-close="handleClose">
      <div>
        <img :src="imageDetails" alt />
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="新建订单进度"
      :visible.sync="dialogUser"
      width="598px"
      :before-close="handleClose">
      <div style="width: 440px; margin: 0 auto; text-align: left;">
        <el-form ref="orderForm" :model="userForm" label-width="140px">
          <el-form-item label="合同甲方：">
            <div style="width:233px">{{signingObj.merchantName}}</div>
          </el-form-item>
          <el-form-item label="合同乙方：">
            <div style="width:233px">{{signingObj.name}}</div>
          </el-form-item>
          <el-form-item label="合同开始时间：">
            <div style="width:233px">{{signingObj.contractStartData}}</div>
          </el-form-item>
          <el-form-item label="合同失效时间：">
            <div style="width:233px">{{signingObj.contractEndData}}</div>
          </el-form-item>
          <el-form-item label="合同文件：">
            <div style="width:233px"><div style="width:100%;height: 125px;background-color: #eee;border: 1px solid #ccc;line-height: 125px;text-align: center;"><a :href="signingObj.contract" target="_blank">合同审核文件</a></div></div>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select v-model="userForm.status" placeholder="请选择">
              <el-option
                v-for="item in auditOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </el-form-item>
          <el-form-item label="备注：">
            <div style="width:233px">
              <el-input
                type="textarea"
                :rows="5"
                resize='none'
                placeholder="请输入内容"
                v-model="userForm.notes">
              </el-input>
            </div>
          </el-form-item>
          <div style="width: 100%;text-align: center;">
            <el-button type="primary" @click="userConfirm">确定</el-button>
            <el-button @click="dialogUser = false">取消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>-->
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      imageDetails: "",
      dialogImg: false,
      pageSzie: 10,
      dialogUser: false,
      auditOptions: [
        {
          value: "2",
          label: "审核失败"
        },
        {
          value: "1",
          label: "审核成功"
        }
      ],
      userListObj: {},
      userForm: {
        id: "",
        notes: "",
        status: ""
      },
      userOptions: [],
      userValue: "",
      orderCodeVal: "",
      statusVal: "",
      statusOptions: [
        {
          value: "2000",
          label: "办理中"
        },
        {
          value: "2010",
          label: "待签约"
        },
        {
          value: "2020",
          label: "已完成"
        }
      ],
      individualBusinessVal: "",
      signingType: true,
      detailsType: true,
      userTableData: [],
      total: null,
      signingObj: {},
      chnNumChar: ["一", "二", "三", "四", "五", "六", "七", "八", "九"],
      detailsOptions: [
        {
          value: "选项2",
          label: "双皮奶"
        }
      ],
      invoicecontents: [
        {
          invoicecontent_id: "1", // 开票内容id
          invoicecontentName: "xx" // 开票内容名称
        }
      ],
      taxUpType: "",
      addValueUpType: "",
      costRate: "",
      taxRate: "",
      serviceRate: "",
      signNotes: "",
      commonTaxLadder: [
        {
          minValue: "",
          maxValue: "",
          quiCalDed: "",
          rate: ""
        }
      ],
      commonOtherLadder: [
        {
          minValue: "",
          zengzhiRate: "",
          fujiaRate: "",
          maxValue: ""
        }
      ],
      specialTaxLadder: [
        {
          minValue: "",
          maxValue: "",
          quiCalDed: "",
          rate: ""
        }
      ],
      specialOtherLadder: [
        {
          minValue: "",
          zengzhiRate: "",
          fujiaRate: "",
          maxValue: ""
        }
      ],
      taxUpOptions: [
        {
          value: "1",
          label: "按年累计"
        },
        {
          value: "2",
          label: "按月累计"
        }
      ],
      addValueUpOptions: [
        {
          value: "1",
          label: "按月累计"
        },
        {
          value: "2",
          label: "按季度累计"
        }
      ]
    };
  },
  mounted() {
    this.userOptions = JSON.parse(localStorage.getItem("nameList")) || [];
    this.businessmenListPost();
    this.invoiceContentPost();
  },
  methods: {
    detailsImage(src) {
      if (src) {
        this.imageDetails = src;
        this.dialogImg = true;
      }
    },
    // 发票内容列表
    invoiceContentPost() {
      post(api.invoiceContentList, {
        currentPage: 1, //非必传
        pageSize: 1000 //非必传
      }).then(
        d => {
          this.detailsOptions = [];
          for (let i = 0; i < d.rows.length; i++) {
            var obj = {
              value: d.rows[i].id,
              label: d.rows[i].name
            };
            this.detailsOptions.push(obj);
          }
          console.log(d, "####################");
        },
        err => {
          console, log(err.msg);
          //error callback
        }
      );
    },
    checkEvent(row) {
      console.log(row);
      this.signingObj = row;
      this.dialogUser = true;
    },
    // 查看详情
    userDetails(row) {
      console.log(row);
      post(api.sohoInfo, {
        id: row.order_id
      }).then(
        d => {
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.detailsType = false;
            this.userListObj = d.data;
          } else {
            this.detailsType = false;
            this.userListObj = row;
          }
        },
        err => {
          this.detailsType = false;
          this.userListObj = row;
          //error callback
        }
      );
    },
    userConfirm() {
      this.userForm.id = this.signingObj.id;
      if (this.userForm.status == "") {
        this.$message({
          showClose: true,
          message: "请选择审核状态",
          type: "warning"
        });
        return;
      }
      if (this.userForm.status == 2 && this.userForm.notes == "") {
        this.$message({
          showClose: true,
          message: "请填写驳回备注",
          type: "warning"
        });
        return;
      }
      post(api.businessmenList, this.userForm).then(
        d => {
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.dialogUser = false;
            this.businessmenListPost();
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClose(done) {
      done();
    },
    // 确定签约
    signingConfirm() {
      post(api.sohoSign, {
        id: this.signingObj.id,
        taxUpType: this.taxUpType,
        addValueUpType: this.addValueUpType,
        costRate: this.costRate,
        taxRate: this.taxRate,
        serviceRate: this.serviceRate,
        signNotes: this.signNotes,
        commonTaxLadder: this.commonTaxLadder,
        commonOtherLadder: this.commonOtherLadder,
        specialTaxLadder: this.specialTaxLadder,
        specialOtherLadder: this.specialOtherLadder
      }).then(
        d => {
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.signingType = true;
            this.businessmenListPost();
          } else {
            console.log(d.msg);
          }
        },
        err => {
          console.log(err.msg);
          //error callback
        }
      );
    },
    // 删除梯度
    delGradient(key, dome) {
      if (this[dome].length == 1) {
        this.$message({
          showClose: true,
          message: "至少保留一条",
          type: "warning"
        });
        return;
      }
      this.$confirm("确定删除第" + this.chnNumChar[key] + "梯队？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this[dome].splice(key, 1);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 添加梯度
    addGradient(dome) {
      var obj = {
        minValue: "",
        maxValue: "",
        rate: ""
      };
      if (this[dome].length < 5) {
        this[dome].push(obj);
      } else {
        this.$message({
          showClose: true,
          message: "最多添加五条",
          type: "warning"
        });
      }
    },
    handleSizeChange(val) {
      this.pageSzie = val;
      console.log(`每页 ${val} 条aaaaa`);
      this.businessmenListPost();
    },
    handleCurrentChange(size) {
      console.log(size);
      this.businessmenListPost(size);
    },
    // 重置
    merchantsReset() {
      this.userValue = "";
      this.orderCodeVal = "";
      this.statusVal = "";
      this.individualBusinessVal = "";
      this.businessmenListPost();
    },
    // 搜索
    merchantsSearch() {
      this.businessmenListPost();
    },
    businessmenListPost(size) {
       const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.sohoAllPage, {
        currentPage: size || 1,
        pageSize: this.pageSzie,
        merchantId: this.userValue,
        orderId: this.orderCodeVal,
        status: this.statusVal
      }).then(
        d => {
          console.log(d.status);
           loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            this.userTableData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    usersSignUp(row) {
      console.log(row);
      this.signingObj = row;
      this.signingType = false;
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.userInformation {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 76px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
  }
  .signing {
    min-width: 1300px;
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
    }
    .header {
      width: 100%;
      // height:75px;
      // background:rgba(242,242,242,0.8);
      border-radius: 6px;
      padding: 28px 27px;
      box-sizing: border-box;
      text-align: left;
      margin-top: 10px;
      .item {
        min-width: 33%;
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        // margin-right: 55px;
        margin-bottom: 15px;
        div {
          display: inline-block;
        }
        span {
          float: left;
        }
      }
      // span {
      //   display: inline-block;
      //   font-size:14px;
      //   font-family:PingFangSC;
      //   font-weight:400;
      //   color:rgba(51,51,51,1);
      //   margin-right: 55px;
      // }
    }
    .subtitle {
      width: 100%;
      height: 53px;
      background: rgba(180, 220, 255, 0.3);
      border-radius: 4px;
      line-height: 53px;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-top: 20px;
      padding-left: 27px;
      box-sizing: border-box;
    }
    .box {
      margin-top: 20px;
      width: 100%;
      // min-height:361px;
      padding-bottom: 20px;
      border-radius: 6px;
      border: 1px solid rgba(195, 195, 195, 0.8);
      .title {
        width: 100%;
        height: 51px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding-left: 27px;
        box-sizing: border-box;
        line-height: 51px;
        text-align: left;
      }
      .content {
        width: 1200px;
        height: auto;
        margin: 0 auto;
        margin-top: 20px;
        div {
          width: 100%;
          padding-right: 10px;
          box-sizing: border-box;
          overflow: hidden;
          position: relative;
          .middle {
            width: 40%;
            height: 100%;
            float: left;
            span {
              display: inline-block;
              width: 210px;
              height: 100%;
              margin-right: 20px;
            }
          }
          .left {
            width: 20%;
            height: 100%;
            float: left;
          }
          .right {
            width: 20%;
            height: 100%;
            float: right;
            span {
              display: inline-block;
              // width:84px;
              height: 100%;
            }
            i:hover {
              color: #409eff;
            }
          }
          i {
            position: absolute;
            right: 10px;
            top: 18px;
            color: #c3c3c3;
            font-size: 18px;
            cursor: pointer;
          }
        }
        .ladder {
          width: 100%;
          height: 56px;
          line-height: 56px;
        }
        .top {
          width: 100%;
          height: 46px;
          line-height: 46px;
          background: rgba(240, 240, 240, 1);
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(70, 92, 109, 1);
        }
        .bottom {
          width: 100%;
          height: 46px;
          line-height: 46px;
          text-align: center;
          background: rgba(232, 244, 255, 1);
          border: 1px solid rgba(193, 225, 255, 1);
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(40, 152, 255, 1);
          cursor: pointer;
        }
      }
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        color: rgba(16, 16, 16, 1);
        font-size: 14px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        .list {
          width: 100%;
          margin-bottom: 20px;
          span {
            display: inline-block;
            width: 33.33%;
            height: 100%;
          }
        }
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
            img {
              cursor: pointer;
              display: block;
              height: 100%;
              margin: 0 auto;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/trading/soho/userAll.vue